<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title> {{ group?.name ? group.name : 'loading' }}</mat-panel-title>
      <mat-panel-description> Description of the Repository</mat-panel-description>
    </mat-expansion-panel-header>
    @for (groupElement of element.groupElement; track $index; let indexOfelement = $index) {
    <div>
      <!-- <ng-container *ngIf="groupElement.typeElement === 'SCRIPT' && group !== undefined">
        <mic-app-run-script-element [script]="group.functionElements[indexOfelement]"></mic-app-run-script-element>
      </ng-container> -->
      @if (groupElement.typeElement === 'IMPORTFILECSV' && group !== undefined) {
      <mic-app-import-file [func]="group.functionElements[indexOfelement]"></mic-app-import-file>
      } @if (groupElement.typeElement === 'TABLE' && group !== undefined) {
      <mic-app-table-visualization [func]="group.functionElements[indexOfelement]"></mic-app-table-visualization>
      } @if (groupElement.typeElement === 'IMPORTFILEXLSX' && group !== undefined) {
      <mic-app-import-file-xlsx [xlsxFunction]="group.functionElements[indexOfelement]"></mic-app-import-file-xlsx>
      }
    </div>
    }
    <div class="delete-btn-container">
      @if (this.user['role'] === 'Admin') {
      <button (click)="onDelete()" class="deleteGroup" mat-flat-button color="warn">
        <mat-icon>delete</mat-icon>
      </button>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
